import { render } from "./Especiales.vue?vue&type=template&id=a445f472&scoped=true"
import script from "./Especiales.vue?vue&type=script&lang=js"
export * from "./Especiales.vue?vue&type=script&lang=js"

import "./Especiales.vue?vue&type=style&index=0&id=a445f472&lang=scss&scoped=true"

import exportComponent from "D:\\Proyectos\\SewayERP\\front-erpseway\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a445f472"]])

export default __exports__